// Funções centralizadas de limpeza de cache
// Importadas aqui para evitar dependências circulares entre hooks e componentes

type ClearFn = () => void;

const registry: ClearFn[] = [];

export const CHAT_CACHE_PREFIX = "ondiet-chat-cache-";
export const QUIZ_STORAGE_KEY = "ondiet-quiz-v2";

/**
 * Chaves de localStorage com dado de saúde que NÃO passam por `registerCacheClear`
 * (o módulo que as escreve é lazy e pode nunca ter sido carregado na sessão).
 * Varridas sempre, de todas as contas — igual ao plano em `usePlanoV2.ts`.
 */
export const PREFIXOS_DE_DADO_DE_SAUDE = [CHAT_CACHE_PREFIX, QUIZ_STORAGE_KEY] as const;

function limparDadoDeSaudeDoDisco(): void {
  try {
    const chaves: string[] = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const chave = localStorage.key(i);
      if (chave && PREFIXOS_DE_DADO_DE_SAUDE.some((p) => chave.startsWith(p))) chaves.push(chave);
    }
    chaves.forEach((chave) => localStorage.removeItem(chave));
  } catch {
    // Sem storage não há o que limpar.
  }
}

/** Registra uma função de limpeza de cache */
export const registerCacheClear = (fn: ClearFn) => {
  registry.push(fn);
};

/** Limpa todos os caches registrados (chamado no logout e na troca de conta) */
export const clearAllCaches = () => {
  registry.forEach((fn) => fn());
  limparDadoDeSaudeDoDisco();
};
